module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.loadFlowContacts),
      expression: "loadFlowContacts"
    }],
    attrs: {
      "infinite-scroll-distance": "10"
    }
  }, [_c('contact-list', {
    attrs: {
      "contacts": _vm.contacts,
      "view_mode": _vm.contactListViewModes().flow,
      "flow": _vm.flow,
      "filters": _vm.filters
    },
    on: {
      "contact-update": _vm.updateContact,
      "contact-recipient-update": _vm.updateContactRecipient,
      "reengage-contact": _vm.reengage,
      "contact-recipient-reset": _vm.openResetContactConfirmationModal,
      "contact-destroy": _vm.openRemoveContactFromFlowModal,
      "toggle-task-bar": _vm.bubbleUp,
      "filter": _vm.filter
    }
  }), _c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('loading', {
    attrs: {
      "loading": _vm.loading
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.next_page),
      expression: "!next_page"
    }],
    staticClass: "light-gray-text light-text"
  }, [_vm._v(_vm._s(_vm.$t('flows.feedback.noDataText')))])], 1), _c('go-to-top', {
    attrs: {
      "offset": 600
    }
  }), _c('reactivate-recipient-modal', {
    attrs: {
      "contact": _vm.schedule_reactivation_contact
    }
  }), _c('confirm-modal', {
    attrs: {
      "id": "confirm-remove-contact-from-flow",
      "title": _vm.$t('contacts.actions.removeFromFlow'),
      "confirm_text": _vm.$t('general.actions.remove'),
      "confirm_class": "btn-danger"
    },
    on: {
      "confirm-modal-confirm": _vm.confirmRemoveContactFromFlow
    }
  }, [_c('br'), _c('div', {
    staticClass: "text-center"
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('flows.label.confirmRemoveContactOnFlow.doYouWishRemove')) + " "), _c('strong', [_vm._v(_vm._s(_vm.selected_contact.full_name))]), _vm._v(" " + _vm._s(_vm.$t('flows.label.confirmRemoveContactOnFlow.fromFlow')) + " "), _c('strong', [_vm._v(_vm._s(_vm.flow.name))]), _vm._v(" ?")]), _c('br'), _c('div', [_c('strong', {
    staticClass: "dark-red-color"
  }, [_vm._v(_vm._s(_vm.$t('flows.label.messageRemoveContactOnFlow.attention')))]), _vm._v(" " + _vm._s(_vm.$t('flows.label.messageRemoveContactOnFlow.flowRemovalConsequence')))])])]), _c('confirm-modal', {
    attrs: {
      "id": "confirm-reset-contact",
      "title": _vm.$t('flows.label.resetContactOnFlow'),
      "message": _vm.$t('flows.label.confirmResetContactOnFlow')
    },
    on: {
      "confirm-modal-confirm": _vm.callResetContact
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-952087ae!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/flows/contacts.vue
// module id = 1192
// module chunks = 1